/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import "./header.css";

const Header = ({ shCusrorAnim, setShCusrorAnim }) => {
  const [showModal, setshowModal] = useState(false);
  const [theme, setTheme] = useState(
    localStorage.getItem("currentMode") ?? "dark"
  );

  useEffect(() => {
    if (theme === "light") {
      document.body.classList.remove("dark");
      document.body.classList.add("light");
    } else {
      document.body.classList.remove("light");
      document.body.classList.add("dark");
    }
  }, [theme]);

  return (
    <>

      <header className="  flex">
        <button
          onClick={() => {
            setshowModal(true);
          }}
          className="menu icon-menu flex"
        >
          {" "}
        </button>
        <div className="show-animat" style={shCusrorAnim ? { opacity: 1 } : { opacity: .7 }} onClick={() => setShCusrorAnim(pre => !pre)} >
          anim <img width={20} src={!shCusrorAnim ? "images/Icons/toggle-off.svg" : "images/Icons/toggle-on.svg"} alt="off" />
        </div>

        <nav>
          <ul className="flex">
            <li>
              <a href="#aboute">About</a>
            </li>
            <li>
              <a href="#projects">Projects</a>
            </li>
            <li>
              <a href="#skils">Skils</a>
            </li>
            <li>
              <a href="#contact">Contact</a>
            </li>
          </ul>
        </nav>


        <button
          onClick={() => {
            // Send value to LS
            localStorage.setItem(
              "currentMode",
              theme === "dark" ? "light" : "dark"
            );

            // get value from LS
            setTheme(localStorage.getItem("currentMode"));
          }}
          className="mode flex"
        >
          {theme === "dark" ? (
            <span className="icon-moon-o"> </span>
          ) : (
            <span className="icon-sun"> </span>
          )}
        </button>

        {showModal && (
          <div className="fixed">
            <ul className="modal ">
              <li>
                <button
                  className="icon-close"
                  onClick={() => {
                    setshowModal(false);
                  }}
                />
              </li>
              <li>
                <a href="#aboute" onClick={() => {
                  setshowModal(false);
                }}>About</a>
              </li>
              <li>
                <a href="#projects" onClick={() => {
                  setshowModal(false);
                }}>Projects</a>
              </li>
              <li>
                <a href="#skils" onClick={() => {
                  setshowModal(false);
                }}>Skils</a>
              </li>
              <li>
                <a href="#contact" onClick={() => {
                  setshowModal(false);
                }}>Contact</a>
              </li>
            </ul>
          </div>
        )}
      </header>
    </>
  );
};

export default Header;
